import isStitcherUrl from './isStitcherUrl';

export default function isArtworkUrl(url = '') {
    return (url.indexOf('artwork.') !== -1 && !isStitcherUrl(url));
}



// WEBPACK FOOTER //
// ./app/lib/url-adapter/isArtworkUrl.js